/** Default social URLs — used when Firestore has no value yet. */
export const DEFAULT_SOCIAL_LINKS = {
  youtube: "https://www.youtube.com/@TargeTube",
  x: "https://x.com/TargeTube",
  tiktok: "https://www.tiktok.com/@targetube",
  facebook: "https://www.facebook.com/TargeTube/",
  linkedin: "https://www.linkedin.com/in/targetubee/",
  instagram: "https://www.instagram.com/targetube/",
  telegram: "https://t.me/TargeTube",
  whatsapp: "https://chat.whatsapp.com/IewrOxSAHNu3cq8mD1T92B",
};

export const SOCIAL_LINK_FIELDS = [
  { key: "youtube", label: "YouTube" },
  { key: "x", label: "X (Twitter)" },
  { key: "tiktok", label: "TikTok" },
  { key: "facebook", label: "Facebook" },
  { key: "linkedin", label: "LinkedIn" },
  { key: "instagram", label: "Instagram" },
  { key: "telegram", label: "Telegram" },
  { key: "whatsapp", label: "WhatsApp" },
];

export function mergeSocialLinks(fromFirestore) {
  // First time (no social_links saved) → prefill defaults in the form.
  if (!fromFirestore || typeof fromFirestore !== "object") {
    return { ...DEFAULT_SOCIAL_LINKS };
  }

  // Saved config → keep empty strings so admin can hide icons.
  const out = {};
  for (const field of SOCIAL_LINK_FIELDS) {
    if (Object.prototype.hasOwnProperty.call(fromFirestore, field.key)) {
      out[field.key] =
        fromFirestore[field.key] == null ? "" : String(fromFirestore[field.key]);
    } else {
      out[field.key] = DEFAULT_SOCIAL_LINKS[field.key];
    }
  }
  return out;
}
